module.exports = __webpack_public_path__ + "ea1eb0415ae56dd95f06068f9ee50cb2.png";